import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import LogoDark from '~/images/logos/swagcharm_logo_by_bluemark.svg';
import LogoLight from '~/images/logos/swagcharm_logo_by_bluemark_dark.svg';
import LogoMobile from '~/images/logos/swagcharm_logo_mobile.svg';
import { MuiRemixLink } from './shared/links';

const LogoImages = {
  light: LogoLight,
  dark: LogoDark,
  mobile: LogoMobile,
};

type LogoVariant = keyof typeof LogoImages;

export default function Logo({
  variant = 'light',
  isResponsive = true,
  isSmall = false,
  handleModalClose,
}: {
  variant?: LogoVariant;
  isResponsive?: boolean;
  isSmall?: boolean;
  handleModalClose?: () => void;
}) {
  const handleOnClick = () => {
    if (handleModalClose) {
      handleModalClose();
    }
  };

  return (
    <Stack>
      {isSmall ? (
        <LogoImage variant="mobile" onClick={handleOnClick} />
      ) : isResponsive ? (
        <>
          <LogoImage variant={variant} onClick={handleOnClick} display={{ xs: 'none', sm: 'flex' }} />
          <LogoImage variant="mobile" onClick={handleOnClick} display={{ xs: 'flex', sm: 'none' }} />
        </>
      ) : (
        <LogoImage variant={variant} onClick={handleOnClick} />
      )}
    </Stack>
  );
}

function LogoImage({
  variant,
  onClick,
  display,
}: {
  variant: LogoVariant;
  onClick: () => void;
  display?: React.ComponentProps<typeof Grid>['display'];
}) {
  const width = variant === 'mobile' ? 38 : 160;
  return (
    <Grid container alignItems="center" pl={1} minWidth={width} display={display}>
      <MuiRemixLink href="/" underline="none" aria-label="SwagCharm" onClick={onClick}>
        <img src={LogoImages[variant]} alt="logo" width={160} height={40} style={{ width, height: 'auto' }} />
      </MuiRemixLink>
    </Grid>
  );
}
